// FestPro: after a product is added to the cart, go to the cart page. Horizon's cart type
// "page" otherwise stays on the product page and only updates the header count.
// Loaded by blocks/buy-buttons.liquid when Theme settings > Cart > "Go to the cart page
// after adding to cart" is on.
import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;

  // The event fires when the add starts; its promise settles when the cart has answered.
  event.promise
    ?.then(({ detail }) => {
      if (detail?.didError) return;
      window.location.assign(Theme.routes.cart_url);
    })
    .catch(() => {
      /* the product form shows the error; stay on the page */
    });
});
